import { useSVGContext } from '../../../../../../contexts/GraphicContext';
import { useFlatsDataContext } from '../../../../../../contexts/FlatsDataContext';

import styles from './FlatsTableHeading.module.css';
import { paths } from '../../../../../../settings';

const FlatsTableHeading: React.FC<{ totalFlats: number }> = ({ totalFlats }): JSX.Element => {
    const { handleResetToGraphicInitialState } = useSVGContext();
    const { contextSelectedFloor } = useFlatsDataContext();
    
    return (
        <div className={styles.wrapper}>
            { contextSelectedFloor 
                ? 
                (<div role="button" className={styles.backButton} onClick={handleResetToGraphicInitialState}>
                    <img src={`${paths.assets}/icons/arrow.png`} width={24} height={24} alt="<" />
                    <span>Wróć do widoku budynku</span>
                </div>) 
                : <></> 
            }
            <div className={styles.headingRow}>
                <div>
                    <h1>Apollo Residence</h1>
                    <p>
                        {totalFlats} apartamentów dostępnych
                    </p>
                </div>
                <div className={styles.contactIcons}>
                    <a href="tel:+48728764854">
                        <img src={`${paths.assets}/icons/phone.png${paths.version}`} title="Zadzwoń" width={34} height={34} alt="Zadzwoń" />
                    </a>
                    <a href="mailto:zapytania@masterm">
                        <img src={`${paths.assets}/icons/mail.png${paths.version}`} title="Napisz" width={34} height={34} alt="Napisz" />
                    </a>
                </div>
            </div>
        </div>
    )
};

export default FlatsTableHeading;